import Crud from './crud'

export default class UserGroupService extends Crud {
  constructor () {
    super('/group')
  }
}
